import React from "react";
import Business from "../../Assets/home/Business-solution.png"
import Home from "../../Assets/home/Home-EV-Charging.png"
import Fast from "../../Assets/home/DC-Fast.png"
import { Button } from '../../Atoms';
import { Link } from 'react-router-dom';

import img1 from "../../Assets/acdevkit/3pinSocket.png";
import img2 from "../../Assets/acdevkit/CMS.png";
import img3 from "../../Assets/acdevkit/Simulator.png";
import img4 from "../../Assets/acdevkit/Type2.png";

const cardData = [
    {
        title: "CMS",
        description: "Add remote monitoring and management capabilities to your AC charger development setup.",
        image: img2,
        link: "/cms",
    },
    {
        title: "EV Simulator",
        description: "Simulate EV charging behaviour and communication for development and testing.",
        image: img3,
        link: "/controllers#simulators",
    },
    {
        title: "Type 2 Charging Gun",
        description: "Add Type 2 charging connectivity for testing and evaluating AC charging solutions.",
        image: img4,
        link: "https://www.amazon.in/dp/B0F9K3JH41",
    },
    {
        title: "3 Pin Socket",
        description: "Add a 3-pin output option for flexible AC charging solution development and testing.",
        image: img1,
        link: "",
    },
   
];

const EVChargingSolutions = () => {
    return (
        <div className="containers-min mx-auto px-4 py-12">
            <h3 className="font-gilroy mb-4 h3 text-4xl">Add-Ons:</h3>
            <div className="flex md:gap-4 gap-2 flex-wrap lg:flex-nowrap justify-around">
                <div>
                    <DataCard {...cardData[0]} />
                </div>
                <div>
                    <DataCard {...cardData[1]} />
                </div>
                <div>
                    <DataCard {...cardData[2]} />
                </div>
                <div>
                    <DataCard {...cardData[3]} />
                </div>
               
            </div>
        </div>
    );
};

const DataCard = ({ title, description, image, link }) => {
    const isExternal = link?.startsWith("http");
    const isClickable = Boolean(link);

    const content = (
        <div className="group h-[225px] Lg:h-[380px] xxl:h-[280px] overflow-hidden grow-0 relative">
            <img
                loading="lazy"
                src={image}
                alt={title}
                className="h-full w-full object-cover "
            />

            <div className="absolute bottom-0 left-0 right-0 bg-gradient-opa py-3 px-4 text-center transition-opacity duration-500 group-hover:opacity-0 z-10">
                <span className="text-xl font-bold font-gilroy">
                    {title}
                </span>
            </div>

            <div className="absolute inset-0 bg-gradient-opa transform translate-y-full group-hover:translate-y-0 transition-transform duration-[1s] flex flex-col items-center justify-center text-center px-4 gap-3 z-20">
                <span className="text-3xl font-bold font-gilroy">
                    {title}
                </span>
                <div className="leading-normal font-poppins text-center text-lg max-w-[90%]">
                    <p className="leading-normal font-poppins text-start text-lg">{description}</p>
                </div>
            </div>
        </div>
    );

    const sharedClassName =
        "basis-96 relative flex flex-col self-stretch grow shrink mx-auto rounded-2xl overflow-hidden group" +
        (isClickable ? " cursor-pointer" : " cursor-default");

    if (!isClickable) {
        return <div className={sharedClassName}>{content}</div>;
    }

    return (
        <Link
            to={link}
            target={isExternal ? "_blank" : undefined}
            rel={isExternal ? "noopener noreferrer" : undefined}
            className={sharedClassName}
        >
            {content}
        </Link>
    );
};

export default EVChargingSolutions;